import React from "react";
import { Provider } from "react-redux";
import { I18nextProvider } from "react-i18next";
import { camelizeKeys } from "humps";
import { parse } from "qs";
import { store } from "main/javascripts/store";
import { HeaderContainer } from "main/javascripts/containers/organisms/Header/HeaderContainer";
import {
  defaultStyles,
  extended,
  GLOBALS,
} from "main/javascripts/styles/globalStyle";
import i18n from "i18n";
import { HotelHead } from "main/javascripts/components/organisms/Hotel/HotelHead";
import { getAbsoluteUrl } from "main/javascripts/utils/UrlUtil";
import { useConstructor } from "main/javascripts/hooks/common/useConstructor";
import { HotelShowParam } from "main/javascripts/models/HotelShowParam";
import {
  fetchHotelsShowPage,
  initHotel,
} from "main/javascripts/features/hotel/hotelSlice";
import { initConstants } from "main/javascripts/actions/Constants";
import { useUserAccount } from "main/javascripts/hooks/common/useUserAccount";
import { HotelShowMain } from "main/javascripts/features/hotel/components/HotelShowMain";
import { initHotelShowParam } from "../../main/javascripts/slices/paramSlice";
import { Footer } from "main/javascripts/components/footer/Footer";
import { Hotel } from "main/javascripts/types/hotel";
import { loadVConsole } from "main/javascripts/utils/DebugUtil";

interface IProps {
  // currentUser: ICurrentUser | null;
  hotel: Hotel.Detail;
  param: HotelShowParam;
  facebookAppId: string;
  locale: string;
  origin: string;
}
loadVConsole(2000);
function HotelShow(props: IProps) {
  const { hotel, param, locale, origin } = props;

  const noindex = hotel.noindex || false;

  useUserAccount(store, true);

  useConstructor(() => {
    store.dispatch(initHotel(hotel)); // RTK
    store.dispatch(initHotelShowParam(camelizeKeys(param))); // RTK
    store.dispatch(initConstants(props));
    if (i18n.language !== locale) {
      void i18n.changeLanguage(locale);
    }
    extended.css(defaultStyles[GLOBALS]);
  });

  return (
    <Provider store={store}>
      <HotelHead origin={origin} hotelName={hotel.name} noindex={noindex} />
      <I18nextProvider i18n={i18n}>
        <>
          <HeaderContainer />
          <HotelShowMain />
          <Footer />
        </>
      </I18nextProvider>
    </Provider>
  );
}

export async function getServerSideProps(ctx) {
  const { origin } = getAbsoluteUrl(ctx.req);
  const locale = ctx.locale;
  const param = ctx.query;
  const hotelId = param.hotelId;
  const data = await store
    .dispatch(
      fetchHotelsShowPage({
        id: hotelId,
        params: parse(param),
        headers: ctx.req.headers,
        isServerSide: true,
      })
    )
    .unwrap();

  return {
    props: {
      origin,
      locale,
      ...data,
    },
  };
}

export default HotelShow;
